import { render, staticRenderFns } from "./CargoExpenseStory.vue?vue&type=template&id=571778fe"
import script from "./CargoExpenseStory.vue?vue&type=script&lang=js"
export * from "./CargoExpenseStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports